
import { Vue, Component } from 'vue-property-decorator';
import VoucherService from '@/services/voucher.service';
import lazyInject from '@/di';

@Component
export default class CorrelationOrderDrawer extends Vue {
  visible = false;

  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  ordrtList: any[] = [];

  totalPrice = 0;

  async init(record: any) {
    const res = await this.voucherService.getDyhOrderVoucherOrderList({
      flow_no: record.flow_no,
      channel: record.channel,

    });
    this.ordrtList = res.list;
    this.totalPrice = res.total_price;
    this.visible = true;
  }

  onClose() {
    this.visible = false;
  }

  deleOrder(order: any) {
    const content = '是否删除订单与收款凭证的绑定关系？';
    console.log(order);
    this.$confirm({
      title: '提示',
      content,
      onOk: () => {
        console.log('ok');
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  }
}
